import { __awaiter } from "tslib";
export const trackingLoader = () => __awaiter(void 0, void 0, void 0, function* () {
    const thirdParty = window.ADAPT.thirdPartyTracking;
    const internal = window.ADAPT.internalTracking;
    if (thirdParty === undefined && internal === undefined) {
        return;
    }
    const { injectImpressionTracking, matchTracking } = yield import(
    /* webpackChunkName: "tracking" */ './universalTracking');
    if (thirdParty) {
        const matchedTracking = matchTracking(thirdParty);
        injectImpressionTracking(matchedTracking);
        window.ADAPT.thirdPartyTracking = matchedTracking;
    }
    if (internal) {
        injectImpressionTracking(internal);
    }
});
